import React from 'react';
import { useNavigate } from 'react-router-dom';
import logoImage from '../css/img/Main_Logo.png';
import '../css/SignupSuccess.css';

function SignupSuccess() {
  const navigate = useNavigate();

  const handleConfirm = () => {
    navigate('/login');
  };

  return (
    <div className="signup-background">
      <div className="signup-page">
        <div className="signup-title">
          <img src={logoImage} alt="AI GROOVE" className="signup-logo-img" />
        </div>
        
        <div className="signup-container">
          <div className="signup-content" id="signup-success-content">
            <div className="signup-header">
              <h1>회원가입 완료</h1>
            </div>
            
            <div className="signup-message-container">
              <p>회원가입 신청이 완료되었습니다.</p>
              <p>관리자 승인 이후 로그인 가능합니다.</p>
            </div>

            <button className="signup-button" onClick={handleConfirm}>
              로그인 페이지로 이동
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignupSuccess; 